import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[grid-header-title-template]' })
export class GridHeaderTitleTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
